const React = require('react')
const PropTypes = require('prop-types')

// NOTE: The default widget ID is the one used by the home page
function VendastaChat({ widgetId = '0935a23f-1ecd-11ef-887e-6655165221ea' }) {
    React.useEffect(() => {
        // Add Vendasta's AI chat widget
        const script = document.createElement('script')
        script.defer = true
        script.async = true
        script.src = 'https://cdn.apigateway.co/webchat-client..prod/sdk.js'
        script.dataset.widgetId = widgetId
        document.getElementsByTagName('head')[0].appendChild(script)

        // Cleanup function
        return () => {
            // Find and remove the script
            const existingScript = document.querySelector(`script[data-widget-id="${widgetId}"]`)
            if (existingScript) {
                existingScript.remove()
            }
        }
    }, [widgetId])

    // This component doesn't render anything visible
    return null
}

VendastaChat.propTypes = {
    widgetId: PropTypes.string,
}

module.exports = VendastaChat
